import SettingProperties from "../../../../contents/docs/integrate/send-events/_snippets/setting-properties-text.mdx";
import NamingTip from "../../../../contents/docs/integrate/send-events/_snippets/naming-tip.mdx";
import Intro from "../../../../contents/docs/integrate/send-events/_snippets/intro.mdx";
import IOSAutocapture from "../../../../contents/docs/libraries/ios/_snippets/autocapture.mdx";
import * as React from 'react';
export default {
  SettingProperties,
  NamingTip,
  Intro,
  IOSAutocapture,
  React
};